<template>
  <RevInfoBlock
    v-if="onHoldPolicies.length > 1"
    :content="
      i18n(translations.multiplePoliciesFailedDescription, {
        failedPoliciesNumber: onHoldPolicies.length,
      })
    "
    :icon="IconWarning"
    :title="
      i18n(translations.multiplePoliciesFailedTitle, {
        failedPoliciesNumber: onHoldPolicies.length,
      })
    "
    variant="danger"
  >
    <ul class="flex flex-col gap-8">
      <li v-for="policy in onHoldPolicies" :key="policy.policyId">
        <RevLink
          :to="{
            name: ROUTE_NAMES.DASHBOARD.POLICY_DETAILS,
            params: { policyId: policy.policyId },
          }"
          :tracking="{
            zone: TRACKING_ZONES.POLICIES_AND_ELIGIBLE_INSURANCES,
            name: 'go-to-policy-details',
            policyName: policy.offerTitle,
            policyState: policy.state,
          }"
        >
          {{ policy.productTitle }}
        </RevLink>
      </li>
    </ul>
  </RevInfoBlock>

  <RevInfoBlock
    v-if="onHoldPolicies.length === 1"
    :content="i18n(translations.updatePaymentMethodDescription)"
    :icon="IconWarning"
    :title="onHoldPolicies[0].productTitle"
    variant="danger"
  >
    <RevButton
      size="small"
      :to="updatePaymentMethodRoute"
      :tracking="{
        zone: TRACKING_ZONES.POLICIES_AND_ELIGIBLE_INSURANCES,
        name: 'update-payment-method',
      }"
      variant="primary"
    >
      {{ i18n(translations.updatePaymentMethodButton) }}
    </RevButton>
  </RevInfoBlock>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { PaymentFlow } from '@backmarket/nuxt-layer-payment/pages/config/flows'
import { usePaymentRouteLocation } from '@backmarket/nuxt-layer-payment/pages/navigation/usePaymentRouteLocation'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLink } from '@ds/components/Link'
import { IconWarning } from '@ds/icons/IconWarning'

import { ROUTE_NAMES } from '@/scopes/dashboard/constants'
import { TRACKING_ZONES } from '~/scopes/dashboard/services-hub/constant'
import type { Policy } from '~/scopes/dashboard/services-hub/types'

import translations from './PolicyIssueInfoBlock.translations'

const props = defineProps<{
  onHoldPolicies: Policy[]
}>()

const i18n = useI18n()

const getPaymentRouteLocation = usePaymentRouteLocation(
  PaymentFlow.INSURANCE_UPDATE_PAYMENT_METHOD,
)

const updatePaymentMethodRoute = computed(() =>
  props.onHoldPolicies.length === 1
    ? getPaymentRouteLocation({
        policyId: props.onHoldPolicies[0].policyId,
      })
    : undefined,
)
</script>
